__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations", "18.2.13", () => (() => (__webpack_require__(7172))), 1);
			register("@angular/cdk", "18.2.14", () => (() => (__webpack_require__(1398))), 1);
			register("@angular/common", "18.2.14", () => (() => (__webpack_require__(316))), 1);
			register("@angular/core", "18.2.13", () => (() => (__webpack_require__(7404))), 1);
			register("@angular/forms", "18.2.13", () => (() => (__webpack_require__(4456))), 1);
			register("@angular/platform-browser", "18.2.13", () => (() => (__webpack_require__(436))), 1);
			register("@angular/router", "18.2.13", () => (() => (__webpack_require__(5072))), 1);
			register("@auth0/angular-jwt", "5.1.2", () => (() => (__webpack_require__(7355))), 1);
			register("@ngx-translate/core", "14.0.0", () => (() => (__webpack_require__(597))), 1);
			register("@ngxs/router-plugin", "3.8.1", () => (() => (__webpack_require__(7039))), 1);
			register("@ngxs/store", "18.1.6", () => (() => (__webpack_require__(8272))), 1);
			register("lodash-es", "4.17.21", () => (() => (__webpack_require__(8315))), 1);
			register("ng2-file-upload", "1.4.0", () => (() => (__webpack_require__(8553))), 1);
			register("rxjs", "7.8.1", () => (() => (__webpack_require__(820))), 1);
			register("shared-components", "0.1.7", () => (() => (__webpack_require__(6331))), 1);
			register("shared-states", "18.0.22", () => (() => (__webpack_require__(4745))), 1);
			register("tslib", "2.6.3", () => (() => (__webpack_require__(4398))), 1);
			register("zone.js", "0.14.10", () => (() => (__webpack_require__(4124))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};